import * as React from 'react';
import { Button, IconChevronRight16, IconChevronLeft16 } from '@cian/ui-kit';
import * as style from './style.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Pagination = function Pagination(_ref) {
  var page = _ref.page,
    lastPage = _ref.lastPage,
    onChange = _ref.onChange;
  if (lastPage < 2) {
    return null;
  }
  var isPrevButtonDisabled = page === 1;
  var isNextButtonDisabled = page === lastPage;
  var onNextPageClick = function onNextPageClick() {
    onChange(page + 1);
  };
  var onPrevPageClick = function onPrevPageClick() {
    onChange(page - 1);
  };
  return /*#__PURE__*/_jsxs("div", {
    className: style['button_group'],
    children: [/*#__PURE__*/_jsx(Button, {
      theme: "fill_secondary",
      disabled: isPrevButtonDisabled,
      onClick: onPrevPageClick,
      beforeIcon: /*#__PURE__*/_jsx(IconChevronLeft16, {
        color: isPrevButtonDisabled ? 'gray20_100' : 'primary_100'
      })
    }), /*#__PURE__*/_jsx(Button, {
      theme: "fill_secondary",
      disabled: isNextButtonDisabled,
      onClick: onNextPageClick,
      beforeIcon: /*#__PURE__*/_jsx(IconChevronRight16, {
        color: isNextButtonDisabled ? 'gray20_100' : 'primary_100'
      })
    })]
  });
};